import { cn } from "@/shared/lib/utils";

/**
 * 文本可见标识(算法备案 §5):AI 文本回复下方「内容由AI生成」小字。
 * 是否渲染由调用方按 `compliance.visibleLabel` 决定(entities 不读 AuthContext)。
 */
export function AiGeneratedNote({ className }: { className?: string }) {
  return (
    <p
      data-testid="ai-generated-note"
      className={cn("mt-1 text-[11px] leading-4 text-muted-foreground/80 select-none", className)}
    >
      内容由AI生成
    </p>
  );
}

/** 音频可见标识:音频播放器旁「AI生成」角标。 */
export function AiAudioBadge({ className }: { className?: string }) {
  return (
    <span
      data-testid="ai-audio-badge"
      className={cn(
        "inline-flex shrink-0 items-center rounded border border-border px-1 py-px text-[10px] leading-4 text-muted-foreground select-none",
        className
      )}
    >
      AI生成
    </span>
  );
}
